"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listVariantGroups = exports.createTransaction = exports.validateTransaction = exports.getOrderStatus = exports.byorderIdcreatedAtPayment = exports.createOrder = exports.getZipCode = exports.checkInventory = exports.getCouponRule = exports.getCoupon = exports.getUser = exports.getInitialData = void 0;
exports.getInitialData = `
  query getInitialData(
    $ltoProductFilter: SearchableProductFilterInput
    $ltoProductSort: [SearchableProductSortInput]
    $ltoProductLimit: Int
    $ltoProductNextToken: String
    $ltoProductFrom: Int
    $ltoProductAggregates: [SearchableProductAggregationInput]
    $ltoProductVariantFilter: ModelVariantFilterInput
    $ltoProductVariantLimit: Int
    $ltoProductImageLimit: Int
    $getStoreSettingInput: GetStoreSettingInput!
    $storeId: ID!
    $deviceType: DeviceType!
    $couponNextToken: String
    $ruleEngineLimit: Int
    $ruleEngineNextToken: String
    $menuFilter: SearchableMenuFilterInput!
    $shippingTierFilter: SearchableShippingTierFilterInput!
  ) {
    getStoreSetting(input: $getStoreSettingInput) {
      id
      configurations {
        ORDER_COUNT
        COD_CHARGES
        PREPAID_DISCOUNT_PERCENT
        MAX_COD_AMOUNT
        MIN_COD_AMOUNT
        MAX_PREPAID_DISCOUNT
        GUEST_CHECKOUT
        COD_ENABLED
        PREPAID_ENABLED
        TIMER_TTILE
        TIMER_DESCRIPTION
        TIMER_COLOR
        TIMER_BG_COLOR
        TIMER_END_TIME
        TIMER_START_TIME
        IS_DAILY_TIMER
        TIMER_ENABLED
        BLOCK_INVENTORY
        GOKWIK_ENABLED
        PPCOD_ENABLED
        PPCOD_AMOUNT
      }
    }

    searchMenus(filter: $menuFilter) {
      items {
        id
        parentId
        storeId
        priority
        menus {
          items {
            id
            parentId
            storeId
            priority
            menus {
              items {
                id
                parentId
                storeId
                priority
                isArchive
                label
                link
                slug
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            isArchive
            label
            link
            slug
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        isArchive
        label
        link
        slug
        createdAt
        updatedAt
        __typename
      }
    }

    getStore(id: $storeId, deviceType: $deviceType) {
      id
      name
      title
      description
      isActive
      webUrl
      trackingUrl
      imageUrl
      darkImageUrl
      banners {
        webKey
        mobileKey
        link
        name
        isArchive
        priority
        deviceType
      }
      announcements {
        label
        link
        color
        textColor
        deviceType
        isArchive
      }
      socialLinks {
        instagram
        facebook
        twitter
        youtube
        pinterest
      }
    }

    searchShippingTiers(filter: $shippingTierFilter) {
      items {
        id
        storeId
        type
        coupons
        paymentType
        amount
        minOrderValue
        maxOrderValue
        createdAt
        updatedAt
        __typename
      }
    }

    listVariantGroups(storeId: $storeId) {
      id
      label
      variantOptions {
        id
        label
      }
    }

    getTopCoupons(
      storeId: $storeId
      deviceType: $deviceType
      nextToken: $couponNextToken
    ) {
      items {
        id
        description
        ppcodCouponAmount
        couponNote
        tAndC
        storeId
        deviceType
        name
        prefix
        couponCodeCount
        maxAllowedUsage
        isArchive
        createdAt
        updatedAt
        couponTitle
        code
        priority
        couponType
        buyXQuantity
        getYAmount
        getYPercentage
        getYQuantity
        getYProducts
        getYStoreProducts {
          id
          title
          price
          listingPrice
          sku
          images {
            items {
              id
              imageKey
              alt
            }
          }
        }
        minOrderValue
        maxDiscount
        expirationDate
        autoApply
        applicableCollections
        applicableProducts
        paymentMethod
        isAffiliated
        isPDPFeatured
        isFeatured
        isBulkCoupon
        showAsNudge
        tAndC
        applyPrepaidDiscount
        applyOnAllVariants
      }
    }

    searchProducts(
      filter: $ltoProductFilter
      sort: $ltoProductSort
      limit: $ltoProductLimit
      nextToken: $ltoProductNextToken
      from: $ltoProductFrom
      aggregates: $ltoProductAggregates
    ) {
      items {
        id
        title
        collections
        vendor
        status
        minimumOrderQuantity
        maximumOrderQuantity
        subCategory {
          name
          slug
        }
        isFeatured
        category {
          name
          slug
        }
        slug
        price
        sku
        position
        listingPrice
        tags
        inventory
        blockedInventory
        continueSellingOutOfStock
        rating
        totalRatings
        thumbImages
        isInventoryEnabled
        totalOrders
        recommended
        recommendPriority
        recommendPrice
        variants(
          filter: $ltoProductVariantFilter
          limit: $ltoProductVariantLimit
        ) {
          items {
            id
            title
            minimumOrderQuantity
            maximumOrderQuantity
            price
            position
            listingPrice
            images {
              items {
                id
              }
            }
            inventory
            blockedInventory
            status
          }
        }
        images(limit: $ltoProductImageLimit) {
          items {
            id
            position
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }
      nextToken
      total
    }

    byStoreIdRuleEngine(
      storeId: $storeId
      limit: $ruleEngineLimit
      nextToken: $ruleEngineNextToken
    ) {
      items {
        id
        storeId
        name
        description
        event
        enabled
        type
        minOrderValue
        maxCashbackAllowed
        cashbackPercentage
        expirePeriodInDays
        cashbackPoint
        couponName
        maxDebitableCashbackPerMonth
        maxCreditableCashbackPerMonth
        conditions {
          event
          attributes {
            key
            operator
            value
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
exports.getUser = `
  query GetUser($storeId: ID) {
    getUser(storeId: $storeId) {
      id
      totalRewards
    }
  }
`;
exports.getCoupon = `
  query GetCoupon($code: ID!) {
    getCoupon(code: $code) {
      id
      description
      couponNote
      tAndC
      couponTitle
      code
      couponType
      buyXQuantity
      getYAmount
      getYPercentage
      getYQuantity
      getYProducts
      getYStoreProducts {
        id
        title
        price
        images {
          items {
            id
            imageKey
            alt
          }
        }
      }
      minOrderValue
      maxDiscount
      expirationDate
      autoApply
      applicableCollections
      applicableProducts
      paymentMethod
      isAffiliated
      isPDPFeatured
      isFeatured
      isBulkCoupon
      showAsNudge
      ppcodCouponAmount
      tAndC
    }
  }
`;
exports.getCouponRule = `
  query GetCouponRule($code: ID!, $storeId: ID!) {
    getCouponRule(code: $code, storeId: $storeId) {
      id
      description
      couponNote
      tAndC
      couponTitle
      code
      couponType
      buyXQuantity
      getYAmount
      getYPercentage
      getYQuantity
      getYProducts
      getYStoreProducts {
        id
        title
        price
        images {
          items {
            id
            imageKey
            alt
          }
        }
      }
      minOrderValue
      maxDiscount
      expirationDate
      autoApply
      applicableCollections
      applicableProducts
      paymentMethod
      ppcodCouponAmount
      isAffiliated
      isPDPFeatured
      isFeatured
      isBulkCoupon
      showAsNudge
      tAndC
    }
  }
`;
exports.checkInventory = `
  mutation CheckInventory($storeId: ID!, $items: [CheckInventoryInput!]!) {
    checkInventory(storeId: $storeId, items: $items) {
      recordKey
      productId
      variantId
      inventory
      collections
      price
      __typename
    }
  }
`;
exports.getZipCode = `
  query GetZipCode($id: ID!) {
    getZipCode(id: $id) {
      id
      codMaxAmount
      cod
      prepaid
      createdAt
      updatedAt
    }
  }
`;
exports.createOrder = `
  mutation CreateOrder($input: CreateNewOrderInput!) {
    createOrder(input: $input) {
      id
      code
      storeId
      userId
      channelName
      totalStoreCredit
      couponCodeId
      totalAmount
      totalCashOnDeliveryCharges
      totalDiscount
      totalGiftCharges
      totalPrepaidAmount
      totalShippingCharges
      taxExempted
      cFormProvided
      thirdPartyShipping
      currency
      paymentType
      appliedRewardPoints
      sla
      priority
      orderDate
      status
    }
  }
`;
exports.byorderIdcreatedAtPayment = `
  query ByorderIdcreatedAtPayment(
    $orderId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byorderIdcreatedAtPayment(
      orderId: $orderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        userId
        orderId
        method
        status
        amount
        paymentDate
        createdAt
        updatedAt
      }
    }
  }
`;
exports.getOrderStatus = `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      code
      storeId
      userId
      channelName
      shippingAddress {
        name
        country
        state
        city
        pinCode
        landmark
        address
        location
        area
      }
      appliedRewardPoints
      billingAddress {
        name
        country
        state
        city
        pinCode
        landmark
        address
        location
        area
      }
      totalStoreCredit
      couponCodeId
      totalAmount
      totalCashOnDeliveryCharges
      totalDiscount
      totalGiftCharges
      totalPrepaidAmount
      totalShippingCharges
      taxExempted
      cFormProvided
      thirdPartyShipping
      totalCashbackRefunded
      cashbackEarned
      currency
      prepaidDiscount
      paymentType
      priority
      orderDate
      status
      source
      checkoutChannel
      createdAt
      updatedAt
    }
  }
`;
exports.validateTransaction = `
  mutation ValidateTransaction($orderId: ID!, $razorpayPaymentId: String!) {
    validateTransaction(
      orderId: $orderId
      razorpayPaymentId: $razorpayPaymentId
    ) {
      success
    }
  }
`;
exports.createTransaction = `
  mutation CreateTransaction($orderId: ID!) {
    createTransaction(orderId: $orderId) {
      orderId
      amount
    }
  }
`;
exports.listVariantGroups = `
  query ListVariantGroups($storeId: ID!) {
    listVariantGroups(storeId: $storeId) {
      id
      label
      variantOptions {
        id
        label
      }
    }
  }
`;
